/**
 * Minimal migration utility for localStorage to cookies
 */

// Simple cookie helper functions
function setCookieSimple(name, value, days = 180) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  const secure = window.location.protocol === 'https:' ? '; secure' : '';
  document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; ${expires}; path=/${secure}; samesite=lax`;
}

function getCookieSimple(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) === 0) {
      try {
        return JSON.parse(decodeURIComponent(cookie.substring(nameEQ.length, cookie.length)));
      } catch (e) {
        return null;
      }
    }
  }
  return null;
}

/**
 * Migration function from localStorage to cookies
 */
export function migrateAuthFromLocalStorage() {
  try {
    // Check if migration already completed
    if (getCookieSimple('auth_migrated_to_cookies')) {
      return { success: true, message: 'Migration already completed', alreadyMigrated: true };
    }

    let migrated = false;
    const migratedItems = [];

    // Migrate user data
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const parsedUserData = JSON.parse(userData);
        if (parsedUserData && parsedUserData.accessToken) {
          setCookieSimple('user', parsedUserData);
          localStorage.removeItem('user');
          migrated = true;
          migratedItems.push('user data');
        }
      } catch (error) {
        // Silent error in production
      }
    }

    // Migrate admin level data
    const adminLevel = localStorage.getItem('currentAdminLevel');
    if (adminLevel) {
      try {
        let adminLevelData;
        try {
          adminLevelData = JSON.parse(adminLevel);
        } catch {
          adminLevelData = adminLevel;
        }
        
        setCookieSimple('currentAdminLevel', adminLevelData);
        localStorage.removeItem('currentAdminLevel');
        migrated = true;
        migratedItems.push('admin level data');
      } catch (error) {
        // Silent error in production
      }
    }

    // Mark migration as completed
    setCookieSimple('auth_migrated_to_cookies', 'true', 365);

    if (migrated) {
      return {
        success: true,
        message: `Migration completed successfully. Migrated: ${migratedItems.join(', ')}`,
        migratedItems
      };
    } else {
      return { success: true, message: 'No data to migrate', newUser: true };
    }

  } catch (error) {
    return { success: false, message: error.message, error };
  }
}

export default migrateAuthFromLocalStorage;
